<template>
  <div>
    <div class="container text-left checkout-configure">
      <h1 class="text-primary font-medium-1" v-if="SERVICE">
        Bestellung Ihrer Tarifkonfiguration
      </h1>

      <b-progress :value="ORDER_STEPS_CURRENT" :max="ORDER_STEPS_TOTAL" class="mb-1 mt-3"></b-progress>

      <div>
        <b-button
            variant="primary"
            size="sm"
            class="mb-1"
            @click="$router.go(-1)"
        >zurück zur Tarifkonfiguration</b-button>
      </div>

      <h2 class="steps-title h3">
        Schritt {{ ORDER_STEPS_CURRENT }} von {{ ORDER_STEPS_TOTAL }} - Bitte füllen Sie Ihre persönlichen Daten aus:
      </h2>

      <billing-address ref="refBillingAddressSection"/>

      <separate-addresses ref="refSeparateAddressesSection"/>

      <order-fee-section v-if="SERVICE && (SERVICE.hasPhone || SERVICE.hasInternet ||  SERVICE.hasTV)"></order-fee-section>

      <t-v-active-section ref="refTvActiveSection" v-if="SERVICE && SERVICE.hasTV"/>

      <installation-home-network ref="refInstallationHomeNetwork" v-if="SERVICE.hasTV || SERVICE.hasPhone || SERVICE.hasInternet"></installation-home-network>

      <f-t-t-h-section ref="refFTTHSection" v-if="SERVICE && (SERVICE.hasPhone || SERVICE.hasInternet)"/>

      <b-card :title="'Anschlussart (Neuanschluss oder Anbieterwechsel)'"  v-if="SERVICE.name.toLowerCase().indexOf('tv-kabelanschluss') === -1 && !isPayTvService()">
        <phoneline-section ref="refPhoneLineSection"/>
      </b-card>

      <phone-number-section ref="refPhoneNumberSection" v-if="getOptionList('phoneOption').length > 0 || getOptionList('phoneOptions').length > 0" />

      <phone-book-section ref="refPhoneBookSection" v-if="getOptionList('phoneOption').length > 0 || getOptionList('phoneOptions').length > 0" />

      <b-card title="Gewünschter Vertragsbeginn" v-if="!isPayTvService()">
        <appointment-section ref="refAppointmentSection"/>
      </b-card>

      <b-card title="Rechnung">
        <invoice-section @change="updateSummary()"/>
      </b-card>

      <b-card title="Sonstige Anmerkungen">
        <comment-section/>
      </b-card>


      <consulting-consent-section ref="refConsultingConsentSection"/>

      <b-card v-if="IS_EMPLOYEE">
        <b-form-group label="MA-ID - Eintrag nur durch Cable 4" label-for="ma-id">
          <b-form-input
              id="ma-id"
              v-model="CHECKOUT_DATA.ma_id"
              placeholder="MA-ID - Eintrag nur durch Cable 4"
          />
        </b-form-group>
      </b-card>

      <b-card title="SEPA-Lastschriftmandat (Abbuchungserlaubnis/Einzugsermächtigung)">
        <sepa-section ref="refBillingSepaSection"/>
      </b-card>

      <b-card>
        <b-button variant="primary" @click="validateData()">Weiter zur Bestellübersicht</b-button>
      </b-card>

      <product-footer></product-footer>
    </div>

    <configuration-summary
        ref="configurationSummary">
    </configuration-summary>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormGroup,
  BFormInput, BCol, BRow, BFormDatepicker, BFormCheckbox
} from "bootstrap-vue";
import SeparateAddresses from "@/views/checkout/sections/SeparateAddresses";
import AdditionalOptionsSection from "@/views/checkout/sections/AdditionalOptionsSection";
import BillingAddress from "@/views/checkout/sections/BillingAddress";
import AppointmentSection from "@/views/checkout/sections/AppointmentSection";
import PhonelineSection from "@/views/checkout/sections/PhonelineSection";
import PhoneNumberSection from "@/views/checkout/sections/PhoneNumberSection";
import PhoneBookSection from "@/views/checkout/sections/PhoneBookSection";
import InvoiceSection from "@/views/checkout/sections/InvoiceSection";
import SepaSection from "@/views/checkout/sections/SepaSection";
import CommentSection from "@/views/checkout/sections/CommentSection";
import TVSection from "@/views/checkout/sections/TVSection";
import FTTHSection from "@/views/checkout/sections/FTTHSection";
import PayTVSection from "@/views/checkout/sections/PayTVSection";
import ConsultingConsentSection from "@/views/checkout/sections/ConsultingConsentSection";
import HardwareSection from "@/views/checkout/sections/HardwareSection";
import FlatratesSection from "@/views/checkout/sections/FlatratesSection";
import ProductFooter from "@/components/ProductFooter";
import InstallationHomeNetwork from "@/views/checkout/sections/InstallationHomeNetwork.vue";
import ConfigurationSummary from "@/views/checkout/configuration/ConfigurationSummary.vue";
import OrderFeeSection from "@/views/checkout/sections/OrderFeeSection.vue";
import TVActiveSection from "@/views/checkout/sections/TVActiveSection.vue";

export default {
  name: "CheckoutAddress",
  components: {
    TVActiveSection, OrderFeeSection,
    ConfigurationSummary,
    SepaSection,
    SeparateAddresses,
    BillingAddress,
    BFormRadioGroup,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    TVSection,
    FTTHSection,
    ConsultingConsentSection,
    CommentSection,
    InvoiceSection,
    PhonelineSection,
    AppointmentSection,
    AdditionalOptionsSection,
    PayTVSection,
    HardwareSection,
    PhoneNumberSection,
    PhoneBookSection,
    FlatratesSection,
    ProductFooter,
    InstallationHomeNetwork,
    ConfigurationSummary,
  },
  data() {
    return {
      address: {},
      value: [],
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS
    }
  },
  beforeMount() {
    this.$store.commit('SET_ORDER_STEPS_CURRENT', 2)

    this.SET_ORDER_STEPS_TOTAL = 3

    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'Availability'})
    }

    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stage') {
      if (this.CHECKOUT_DATA.billingAddress.firstname === '') {
        this.CHECKOUT_DATA.billingAddress.firstname = 'Max'
        this.CHECKOUT_DATA.billingAddress.name = 'Mustermann'
        this.CHECKOUT_DATA.billingAddress.birthday = ''
        this.CHECKOUT_DATA.billingAddress.phone = '0151123456789'
        this.CHECKOUT_DATA.bankaccount.firstname = 'Max'
        this.CHECKOUT_DATA.bankaccount.name = 'Mustermann'
        this.CHECKOUT_DATA.bankaccount.bankname = 'Postbank'
        this.CHECKOUT_DATA.bankaccount.iban = 'DE91100000000123456789'
        this.CHECKOUT_DATA.bankaccount.bic = 'PBNKDEFF'
        this.CHECKOUT_DATA.consulting_consent = '0'
        this.CHECKOUT_DATA.tv = '0'
        this.CHECKOUT_DATA.birthday = '1980-01-01'
      }
    }

  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'ORDER_STEPS_CURRENT', 'ORDER_STEPS_TOTAL', 'IS_EMPLOYEE', 'PRODUCTS']),
    state() {
      return Boolean(this.CHECKOUT_DATA.salutation)
    },
  },
  methods: {
    validateData() {
      for (let ref in this.$refs) {
        const current = this.$refs[ref]

        if (current && typeof current.validateForm === "function") {
          current.validateForm()
        }
      }

      let self = this

      setTimeout(function () {
        //check if some form validation error exists
        if (document.querySelectorAll(".text-danger.has-errors").length > 0) {
          self.$bvToast.toast('Es ist ein Fehler im Formular aufgetreten. Bitte überprüfen Sie Ihre Eingabe.', {
            title: 'Fehler',
            variant: 'danger',
            toaster: 'b-toaster-bottom-right',
            noCloseButton: true
          })

          //scroll to the first error
          let yOffset = -80;
          let el = document.querySelector(".text-danger.has-errors")
          let y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({top: y, behavior: 'smooth'});
        } else {
          //redirect to next checkout page
          self.$router.push({name: 'Checkout Overview'})
        }
      }, 200);
    },
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    isPayTvService() {
      return !this.SERVICE.hasTV && !this.SERVICE.hasPhone && !this.SERVICE.hasInternet
    },
    hasPayTVOptions() {
      if (this.SERVICE) {
        for (let serviceOptionGroup of this.SERVICE.serviceOptions) {
          if (serviceOptionGroup.description.toLowerCase().indexOf('pay-tv') > -1 && serviceOptionGroup.children.length > 0) {
            return true;
          }
        }
      }

      return false
    },
    hasCableTVOptions() {
      for (let product of this.PRODUCTS) {
        if (product.name.toLowerCase().indexOf('tv-kabelanschluss') > -1) {
          return true;
        }
      }

      return false
    },
    updateSummary() {
      this.$refs.configurationSummary.updateSummary()
    },
    getOptionList(model) {
      const options = this.CHECKOUT_DATA[model] || {}
      return Object.keys(options).reduce((acc, key) => acc.concat(options[key]), [])
    },
  }

}
</script>

<style lang="scss">
.inner-section {
  padding-left: 1.8rem;
}
.checkout-configure {
  padding-bottom: var(--configuration-summary-height, 120px);
}
</style>
